module.exports = __webpack_public_path__ + "static/media/20240130082425_IMG_5062 (1).f4bc6a50.jpg";